export const SET_TAG = 'TAG/SET_TAG'
export const SET_TAGS = 'TAG/SET_TAGS'
